import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Grid, Typography, Button, Hidden, CircularProgress, colors, } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  buttonProgress: {
    color: colors.green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  loading: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1,
  }
}));

const TableEditBar = props => {
  const {
    isLoading,
    actions,
    selected,
    className,
    ...rest
  } = props;

  const classes = useStyles();
  const open = selected.length > 0;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      // eslint-disable-next-line react/jsx-sort-props
      PaperProps={{ elevation: 1 }}
      variant="persistent"
    >
      {isLoading && (
        <div className={classes.loading}>
          <CircularProgress size={24} className={classes.buttonProgress} />
        </div>
      )}
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Grid
          alignItems="center"
          container
          spacing={2}
        >
          <Hidden smDown>
            <Grid
              item
              md={3}
            >
              <Typography
                color="textSecondary"
                variant="subtitle1"
              >
                {selected.length} selected
              </Typography>
            </Grid>
          </Hidden>
          <Grid
            item
            md={6}
            xs={12}
          >
            <div className={classes.actions}>
              {actions && actions.map((action, index) => {
                const ActionIcon = action.iconElement
                return (
                  <Button key={action.label} onClick={action.onClick}>
                    <ActionIcon className={classes.buttonIcon} />
                    {action.label}
                  </Button>
                )
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

TableEditBar.propTypes = {
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.array.isRequired
};

export default TableEditBar;
